import c0 from './bridge/notification_token_controller';
import c1 from './bridge/playback_listener_controller';
import c2 from './bridge/review_prompt_controller';
import c3 from './bridge/scroll_reveal_controller';
import c4 from './carousel_controller';
import c5 from './keyboard_viewport_controller';
import c6 from './poll_options_controller';
import c7 from './push_notifications_controller';
import c8 from './read_tracking_controller';
import c9 from './scroll_reveal_controller';
import c10 from './sticky_shadow_controller';
import c11 from './thread_images_controller';
import c12 from './waveform_controller';
export const definitions = [
	{identifier: 'bridge--notification-token', controllerConstructor: c0},
	{identifier: 'bridge--playback-listener', controllerConstructor: c1},
	{identifier: 'bridge--review-prompt', controllerConstructor: c2},
	{identifier: 'bridge--scroll-reveal', controllerConstructor: c3},
	{identifier: 'carousel', controllerConstructor: c4},
	{identifier: 'keyboard-viewport', controllerConstructor: c5},
	{identifier: 'poll-options', controllerConstructor: c6},
	{identifier: 'push-notifications', controllerConstructor: c7},
	{identifier: 'read-tracking', controllerConstructor: c8},
	{identifier: 'scroll-reveal', controllerConstructor: c9},
	{identifier: 'sticky-shadow', controllerConstructor: c10},
	{identifier: 'thread-images', controllerConstructor: c11},
	{identifier: 'waveform', controllerConstructor: c12},
];
